import { getActionFromFormRouteUrl } from './getActionFromFormRouteUrl';

export const getFormLabel = (
  formType: string,
  form: any,
  dataset: any,
  pathname: string
) => {
  if (!form) return undefined;

  if (formType === 'edit') {
    return form.captions.edit;
  }
  if (formType === 'other') {
    return `${dataset?.label} ${getActionFromFormRouteUrl(pathname)}`;
  }
  return form.captions.insert;
};
